
import { defineComponent, computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import StoreUtil from '@/stores/StoreUtil'
import InputText from '@/components/common/field/InputText.vue'
import useMaintenanceStatus from '@/Hooks/useMaintenanceStatus'

export default defineComponent({
  name: 'AddTeamPage',
  setup() {
    const router = useRouter()
    const enterAccountStore = StoreUtil.useStore('EnterAccountStore')
    const messageDialogStore = StoreUtil.useStore('MessageDialogStore')
    const ErrorStore = StoreUtil.useStore('ErrorStore')
    const loginStore = StoreUtil.useStore('LoginStore')
    const { checkMaintenanceStatusByApiBaseUrl } = useMaintenanceStatus()
    const inFieldUserName = ref<InstanceType<typeof InputText>>()
    const inFieldPassword = ref<InstanceType<typeof InputText>>()
    const isEnableButton = computed(
      () => inFieldUserName.value?.meta.valid && inFieldPassword.value?.meta.valid,
    )
    const { t } = useI18n()

    onMounted(async () => {
      const isAvailable = await checkMaintenanceStatusByApiBaseUrl()
      if (!isAvailable) {
        router.replace({ name: 'MaintenancePage' })
        return
      }
      enterAccountStore.isInvitedUser = true
      enterAccountStore.isExistingAccount = true
      if (typeof router.currentRoute.value.query.tokenId !== 'string') {
        ErrorStore.setConfig('tokenInvalid.invite')
        router.replace({ name: 'ErrorPage' })
        return
      }
      enterAccountStore.tokenId = router.currentRoute.value.query.tokenId
      const validationResult = await enterAccountStore.validateToken()
      if (!validationResult.isSuccess || !validationResult.res.data.isValid) {
        await messageDialogStore.openWithSettings({
          title: t('EnterAccountPage.urlInvalidError.title'),
          message: t('EnterAccountPage.urlInvalidError.messageForInvite'),
          status: 'error',
        })
        ErrorStore.setConfig('tokenInvalid.invite')
        router.replace({ name: 'ErrorPage' })
      }
    })
    return {
      enterAccountStore,
      isEnableButton,
      t,
      inFieldUserName,
      inFieldPassword,
      async onClickEnterAccount() {
        const res = await enterAccountStore.fetchAccessToken()

        if (!res.isSuccess) {
          await messageDialogStore.openWithSettings({
            title: t('AddTeamPage.loginErrorDialog.title'),
            message: t('AddTeamPage.loginErrorDialog.message'),
            status: 'caution',
            cancelButton: false,
          })
          return
        }

        // メールアドレスが登録されていない場合（ LINE で登録されたアカウント）、メールアドレス登録画面に遷移する。
        if (!loginStore.mailAddress) {
          router.push({
            name: 'MailAddressRegistrationPage',
            query: { tokenId: enterAccountStore.tokenId },
          })
          return
        }

        router.replace({ name: 'InviteConfirmationPage' })
      },
    }
  },
  components: {
    RegisterFlow,
    InputText,
  },
})
